export default {
  product: {
    new: 'Nuevo elemento del catálogo',
    data: 'Introduzca los datos del nuevo artículo del catálogo',
    add: 'Incluir en catálogo',
    addAndSelect: 'Incluir en catálogo y seleccionar'
  },
  productsTable: {
    modifyAndUpdate: 'Modifique los datos del artículo y pulse sobre "Actualizar artículo" para conservar los cambios realizados',
    saveNew: 'Guardar como nuevo elemento',
    create: 'Crear',
    update: 'Actualizar',
    createAndSelect: 'Crear y seleccionar',
    updateAndSelect: 'Actualizar y seleccionar',
    undo: 'Deshacer cambios',
    select: 'Seleccionar',
    noResults: 'No se encontraron resultados',
    vendorCode: 'Cód. Vendedor ',
    description: 'Descripción',
    price: 'Precio'
  },
  searchCatalog: {
    catalog: 'Catálogo',
    products: 'Productos/Servicios',
    search: 'Buscar en el catálogo',
    showing: 'Mostrando',
    vendorCode: 'Código vendedor',
    description: 'Descripción',
    price: 'Precio',
    more: 'Ver más',
    newElement: 'Nuevo elemento',
    addSelected: 'Añadir seleccionado',
    deleteTitle: 'Eliminar productos seleccionados',
    deleteConfirm: '¿Está seguro que desea eliminar los productos seleccionados?'
  },
  catalogView: {
    deleteTitle: 'Listado de productos seleccionados para eliminar',
    success: 'Los productos fueron eliminados con éxito.'
  }
}
